/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Chat_Suggestions_Welcome_15Inputs */

const es_chat_suggestions_welcome_15 = /** @type {(inputs: Chat_Suggestions_Welcome_15Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cuando quieras, ${i?.name}. ¿Por dónde empezamos?`)
};

const en_chat_suggestions_welcome_15 = /** @type {(inputs: Chat_Suggestions_Welcome_15Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Whenever you're ready, ${i?.name}. Where should we start?`)
};

/**
* | output |
* | --- |
* | "Whenever you're ready, {name}. Where should we start?" |
*
* @param {Chat_Suggestions_Welcome_15Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_suggestions_welcome_15 = /** @type {((inputs: Chat_Suggestions_Welcome_15Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Suggestions_Welcome_15Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_suggestions_welcome_15(inputs)
	return en_chat_suggestions_welcome_15(inputs)
});
export { chat_suggestions_welcome_15 as "chat.suggestions.welcome_15" }